export const REGION_PAYMENT_RATE_MIN = 0.01;
export const REGION_PAYMENT_RATE_MAX = 99.99;
export const REGION_COST_PER_BOARD_MIN = 0;

export const REGION_COST_PER_SQFT_MIN = 0;

/** Exterior One / Exterior Two share of the Exterior Siding/Paint amount. */
export const EXTERIOR_PAYOUT_PERCENTAGE_MIN = 0;
export const EXTERIOR_PAYOUT_PERCENTAGE_MAX = 100;
/** Offset Subdivisions store a signed delta against the Region value. */
export const SUBDIVISION_EXTERIOR_PAYOUT_OFFSET_MIN = -100;
